module.exports = __webpack_public_path__ + "img/gift.5081b50b.jpg";